$description = $(".map__tooltip");

$(".map__item").hover(
  function () {
    $(this).attr("class", "map__item");
    $description.addClass("active");
    $description.html($(this).children(".map__title").html());
  },
  function () {
    $description.removeClass("active");
  }
);

$(document).on("mousemove", function (e) {
  $description.css({
    left: e.pageX - 96,
    top: e.pageY - 16
  });
});
